import React from 'react';

const ICONS = {
  success: 'fa-check',
  warning: 'fa-exclamation',
  error: 'fa-times',
  info: 'fa-info',
};

const CustomToast = ({ type = 'info', title, description }) => (
  <div className={`serveiq-toast serveiq-toast--${type}`}>
    <div className="serveiq-toast__accent" />
    <div className="serveiq-toast__icon">
      <i className={`fa ${ICONS[type] || ICONS.info}`} aria-hidden="true" />
    </div>
    <div className="serveiq-toast__content">
      <div className="serveiq-toast__title">{title}</div>
      {description && <div className="serveiq-toast__description">{description}</div>}
    </div>
  </div>
);

export default CustomToast;
